import { Action } from '@ngrx/store';
import { type } from '@app/store/util';
import { Partij, Rol, Betrokkene, FormPerson } from '@app/core/interfaces/partij';
export const LOAD = type('[Involved Parties] Load Involved Parties');
export const LOAD_SUCCESS = type('[Involved Parties] Load Involved Parties Success');

export const SET_DRIVER = type('[Involved Parties] Set Driver');
export const SET_WITNESS = type('[Involved Parties] Set Witness');
export const SET_CONTACT = type('[Involved Parties] Set Contact');
export const SET_CO_INSURED = type('[Involved Parties] Set Co Inshured');
export const SET_COUNTER_PARTY = type('[Involved Parties] Set Counter Party');

export const UPDATE_NATURAL_PERSON = type('[Involved Parties] Update Natural Person');
export const UPDATE_BETROKKENE = type('[Involved Parties] Update Betrokkene');

export const SET_ERRORS = type('[Involved Parties] Set Errors');
export const CLEAR_ERRORS = type('[Involved Parties] Clear Errors');

export const SET_DRIVER_COUNTER_PARTY = type('[Involved Parties] Set Driver Counter Party');
export const UPDATE_DRIVER_NATURAL_PERSON = type('[Involved Parties] Update Driver Natural Person');
export const UPDATE_DRIVER_NOT_NATURAL_PERSON = type('[Involved Parties] Update Driver Not Natural Person');

export class Load implements Action {
    public type: string = LOAD;
    constructor(public payload: { relatie_id: number, dossier_volgnummer: number }) {}
}

export class LoadSuccess implements Action {
    public type: string = LOAD_SUCCESS;
    constructor(public payload: { dossier_volgnummer: number, entity: Partij }) {}
}

export class SetDriver implements Action {
    public type: string = SET_DRIVER;
    constructor(public payload: { dossier_volgnummer: number, persoon: FormPerson; }) {}
}

export class SetWitness implements Action {
    public type: string = SET_WITNESS;
    constructor(public payload: { relatie_id: number, dossier_volgnummer: number, persoon: FormPerson; }) {}
}

export class SetContact implements Action {
    public type: string = SET_CONTACT;
    constructor(public payload: { relatie_id: number, dossier_volgnummer: number, persoon: FormPerson; }) {}
}

export class SetCoInsured implements Action {
    public type: string = SET_CO_INSURED;
    constructor(public payload: { relatie_id: number, dossier_volgnummer: number, persoon: FormPerson; }) {}
}

export class SetCounterParty implements Action {
    public type: string = SET_COUNTER_PARTY;
    constructor(public payload: { relatie_id: number, dossier_volgnummer: number, persoon: FormPerson, np_of_nnp_code: string }) {}
}

export class UpdateNaturalPerson implements Action {
    public type: string = UPDATE_NATURAL_PERSON;
    constructor(public payload: { dossier_volgnummer: number, persoon: FormPerson, rol: Rol }) {}
}

export class UpdateBetrokkene implements Action {
    public type: string = UPDATE_BETROKKENE;
    constructor(public payload: { dossier_volgnummer: number, type: string, betrokkene: Betrokkene }) {}
}

export class SetErrors implements Action {
    public type: string = SET_ERRORS;
    constructor(public payload: { dossier_volgnummer: number, errors: any[] }) {}
}

export class ClearErrors implements Action {
    public type: string = CLEAR_ERRORS;
    constructor(public payload: any) {} // dossier_volgnummer
}

export class SetDriverCounterParty implements Action {
    public type: string = SET_DRIVER_COUNTER_PARTY;
    constructor(
        public payload: {
            relatie_id: number,
            dossier_volgnummer: number,
            persoon: FormPerson,
            tegenpartij_volgnummer: number,
            adres_relatie_id: number
        }
    ) {}
}

export class UpdateDriverNaturalPerson implements Action {
    public type: string = UPDATE_DRIVER_NATURAL_PERSON;
    constructor(public payload: { dossier_volgnummer: number, persoon: FormPerson, adres_relatie_id: number }) {}
}

export class UpdateDriverNotNaturalPerson implements Action {
    public type: string = UPDATE_DRIVER_NOT_NATURAL_PERSON;
    constructor(public payload: { dossier_volgnummer: number, persoon: FormPerson, adres_relatie_id: number }) {}
}

export type Actions
    = Load
    | LoadSuccess
    | SetDriver
    | SetWitness
    | SetContact
    | SetCoInsured
    | SetCounterParty
    | UpdateNaturalPerson
    | UpdateBetrokkene
    | SetErrors
    | ClearErrors
    | SetDriverCounterParty
    | UpdateDriverNaturalPerson
    | UpdateDriverNotNaturalPerson;
